import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CardIcon } from 'src/app/utils/interfaces/old/card-icon-interface';

@Component({
  selector: 'frg-cards',
  templateUrl: './cards.fragment.html',
  styleUrls: ['./cards.fragment.scss']
})
export class CardsFragment implements OnInit, AfterViewInit {

  @ViewChild('emptyIconRef') public emptyIconElem: ElementRef;
  @ViewChild('emptyIcon1Ref') public emptyIconElem1: ElementRef;
  @ViewChild('fullIcon1Ref') public fullIconElem: ElementRef;
  @ViewChild('emptyIcon2Ref') public emptyIcon2Elem: ElementRef;
  @ViewChild('subtitleColorRef') public subtitleColorRef: ElementRef;

  @Input() public title: string;
  @Input() public subtitle: string;
  @Input() public subtitleColor: string;
  @Input() public emptyIcon?: CardIcon;
  @Input() public emptyIcon1?: CardIcon;
  @Input() public fullIcon?: CardIcon;
  @Input() public emptyIcon2?: CardIcon;
  @Input() public border = true;
  @Input() public isEmptyIcon2Active = false;
  @Input() public menuLinks?: {title: string; src?: string ; links:[{text: string; link?: string; target?: string; existingFunction?: Function}]};


  @Output() public activatedEmpty = new EventEmitter();
  @Output() public activatedEmpty1 = new EventEmitter();
  @Output() public activatedFull = new EventEmitter();
  @Output() public activatedEmpty2 = new EventEmitter();

  constructor() { }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    if (this.emptyIcon && this.emptyIcon.color && this.emptyIconElem) {
      this.emptyIconElem.nativeElement.style.border = 'solid 1px ' + this.emptyIcon.color;
    }
    if (this.emptyIcon1 && this.emptyIcon1.color && this.emptyIconElem1) {
      this.emptyIconElem1.nativeElement.style.border = 'solid 1px ' + this.emptyIcon1.color;
    }
    if (this.fullIcon && this.fullIcon.color && this.fullIconElem) {
      this.fullIconElem.nativeElement.style.background = this.fullIcon.color;
      this.setBoxShadow();
    }
    if (this.emptyIcon2 && this.emptyIcon2.color && this.emptyIcon2Elem && this.isEmptyIcon2Active) {
      this.emptyIcon2Elem.nativeElement.style.background = this.emptyIcon2.color;
      this.setBoxShadow();
    }
    if (this.subtitleColor) {
      this.subtitleColorRef.nativeElement.style.color = this.subtitleColor;
    }
  }

  // Ajoute un boxShadow de la couleur passé en paramètre.
  // La couleur peut-être de l'hexadécimal ou une variable.
  public setBoxShadow(): void {
    let colorToRGB;
    // Si elle contient un # et fais 7 ou 4 de long c'est de l'hexadécimal (#fff ou #ffffff)
    if (this.fullIcon.color.includes('#') && this.fullIcon.color.trim().length === 7 || this.fullIcon.color.trim().length === 4) {
      colorToRGB = this.hexToRgb(this.fullIcon.color);
    } else {
      // Si c'est une variable, il faut aller chercher sa valeur hexadécimal.
      // Pour ce faire il faut lui envoyer seulement le nom de la variable, on la découpe donc (slice)
      let styleToHex = getComputedStyle(document.documentElement)
        .getPropertyValue(this.fullIcon.color.slice(4, this.fullIcon.color.length - 1));
      if (styleToHex.toLowerCase() === "#fff") {
        styleToHex = '#ffffff';
      } else if (styleToHex === "#000") {
        styleToHex = "#000000";
      }
      colorToRGB = this.hexToRgb(styleToHex.trim());
    }
    if (colorToRGB) {
      this.fullIconElem.nativeElement.style.boxShadow = `0px 8px 16px rgba(${colorToRGB.r}, ${colorToRGB.g}, ${colorToRGB.b}, 0.14), 0px 4px 8px rgba(${colorToRGB.r}, ${colorToRGB.g}, ${colorToRGB.b}, 0.14)`;
    } else {
      this.fullIconElem.nativeElement.style.boxShadow = `0px 8px 16px rgba(0, 0, 0, 0.14), 0px 4px 8px rgba(0, 0, 0, 0.14)`;
    }
  }

  // Transforme l'hexadécimal en rgb
  private hexToRgb(hex: string): any {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  public activeEmpty(): void {
    this.activatedEmpty.emit();
  }
  
  public activeEmpty1(): void {
    this.activatedEmpty1.emit();
  }

  public activeFull(): void {
    this.activatedFull.emit();
  }

  public activeEmpty2(): void {
    this.activatedEmpty2.emit();
  }

  openLink(link: string, target: string, existingFunction: Function) {
    if(link && target){
      window.open(link, target);
    }else if(existingFunction){
      existingFunction()
    }
   
  }
}
